import React, { Component } from 'react';
import Table from "react-bootstrap/Table";
import { Collapse } from 'react-bootstrap';
import Translation from "../../../common/translation/translation.component";
import './../../../common/modal/modal.component.css';

export class RequestOnBehalfDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showUserDetails: false
        };
    }

    render() {
        const { robDetails, isRob } = this.props;
        return (
            isRob && robDetails != null && (
                <div>                    
                    <Table className='details-onbehalf-container mb-0 mt-0'>
                        <tbody>
                            <tr>
                                <td className="custom-label-request-onbehalf"><Translation translationKey="request_on_behalf_for" /></td>
                                <td>{robDetails.LastName + ', ' + robDetails.FirstName}</td></tr>
                            <tr>
                                <td></td>
                                <td>{robDetails?.Email}</td>                               
                            </tr>
                            <tr>
                                <td></td>
                                <td>{robDetails?.Location?.LocationSite + ' - ' + robDetails?.Location?.LocationCity + ', ' + robDetails?.Location?.CountryName}</td>
                            </tr>
                        </tbody>
                    </Table>                    
                </div>
            )
        );
    }
};